import { Card, CardTitle, Hr, Muted, Spinner } from './ui';
import { formatBytes } from './formatBytes';


function StorageMeterContent(props: { usedBytes: number; limitBytes: number; loading?: boolean }) {
  const used = Math.max(0, Number(props.usedBytes || 0));
  const limit = Math.max(1, Number(props.limitBytes || 0) || 1);
  const pct = Math.max(0, Math.min(100, (used / limit) * 100));

  return (
    <div style={{ display: 'grid', gap: 8 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12 }}>
        <Muted style={{ margin: 0, fontSize: 12 }}>Storage — {formatBytes(used)} / {formatBytes(limit)}</Muted>
        <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexShrink: 0 }}>
          <Muted style={{ margin: 0, fontSize: 12 }}>{Math.round(pct)}%</Muted>
          {props.loading && <Spinner size={10} />}
        </div>
      </div>

      <div
        style={{
          height: 6,
          borderRadius: 999,
          overflow: 'hidden',
          border: '1px solid rgba(210,180,91,0.25)',
          background: 'rgba(0,0,0,0.18)'
        }}
      >
        <div
          style={{
            height: '100%',
            width: `${pct}%`,
            background:
              pct < 90
                ? 'linear-gradient(90deg, rgba(200,173,106,0.95), rgba(234,207,142,0.85))'
                : 'linear-gradient(90deg, rgba(224,90,90,0.95), rgba(224,90,90,0.55))',
            boxShadow: pct < 90
              ? '0 0 8px rgba(200,173,106,0.45)'
              : '0 0 8px rgba(224,90,90,0.55)',
            transition: 'width 250ms ease, background 250ms ease'
          }}
        />
      </div>
    </div>
  );
}

export default function StorageMeter(props: {
  usedBytes: number;
  limitBytes: number;
  bare?: boolean;
  loading?: boolean;
  onBuyMore?: () => void;
}) {
  if (props.bare) {
    return <StorageMeterContent usedBytes={props.usedBytes} limitBytes={props.limitBytes} loading={props.loading} />;
  }

  return (
    <Card>
      <CardTitle>Storage</CardTitle>
      <Muted>Encrypted storage for files attached to your messages.</Muted>
      <Hr />
      <StorageMeterContent usedBytes={props.usedBytes} limitBytes={props.limitBytes} loading={props.loading} />
    </Card>
  );
}
